/** Shared option lists for organization / Brand Brain forms. Labels are i18n-agnostic codes rendered by Intl when possible. */

export const COUNTRIES = ["CH", "FR", "BE", "DE", "IT", "LU", "AT", "ES", "PT", "NL", "GB", "CA", "US", "MA", "TN", "SN", "CI"];
export const CURRENCIES = ["CHF", "EUR", "USD", "GBP", "CAD"];
export const TIMEZONES = ["Europe/Zurich", "Europe/Paris", "Europe/Brussels", "Europe/Berlin", "Europe/Rome", "Europe/Madrid", "Europe/Lisbon", "Europe/London", "America/Montreal", "America/New_York", "Africa/Casablanca", "Africa/Dakar"];
export const CONTENT_LANGUAGES = ["fr", "de", "it", "en", "es", "pt"];
export const GOAL_KEYS = ["leads", "appointments", "sales", "awareness", "community", "retention", "other"];

export function countryName(code, locale = "fr-CH") {
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(code) || code;
  } catch (e) {
    return code;
  }
}

export function languageName(code, locale = "fr-CH") {
  try {
    const name = new Intl.DisplayNames([locale], { type: "language" }).of(code) || code;
    return name.charAt(0).toUpperCase() + name.slice(1);
  } catch (e) {
    return code;
  }
}
